'use client';

import { CheckIcon } from '@radix-ui/react-icons';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import * as React from 'react';
import { ComponentRef } from 'react';

import { cn } from '../../lib/utils';

const RadioGroup = React.forwardRef<ComponentRef<typeof RadioGroupPrimitive.Root>, React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>>(
	({ className, ...props }, ref) => {
		return <RadioGroupPrimitive.Root className={cn('grid gap-2', className)} {...props} ref={ref} />;
	}
);
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

type RadioGroupItemProps = React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> & {
	icon?: (props: { className: string }) => React.ReactNode;
};

const RadioGroupItem = React.forwardRef<ComponentRef<typeof RadioGroupPrimitive.Item>, RadioGroupItemProps>(({ className, icon, ...props }, ref) => {
	const defaultClassName = 'size-3.5 fill-primary';
	const iconNode = icon ? icon({ className: defaultClassName }) : <CheckIcon className={defaultClassName} />;
	return (
		<RadioGroupPrimitive.Item
			ref={ref}
			className={cn(
				'aspect-square size-4 rounded-full border border-primary text-primary shadow focus:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
				className
			)}
			{...props}
		>
			<RadioGroupPrimitive.Indicator className="flex items-center justify-center">{iconNode}</RadioGroupPrimitive.Indicator>
		</RadioGroupPrimitive.Item>
	);
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
